export interface IndicatorLabelSource {
  name: string;
  displayName?: string | null;
}

/** The label shown to users for a lab indicator definition: display name, else name. */
export const getIndicatorLabel = (definition: IndicatorLabelSource) =>
  definition.displayName?.trim() || definition.name;

/** Locale-aware, case-insensitive, numeric-aware label ordering. */
export const compareIndicatorLabels = (a: string, b: string) =>
  a.localeCompare(b, undefined, { sensitivity: "base", numeric: true });

export const compareIndicatorDefinitions = (
  a: IndicatorLabelSource,
  b: IndicatorLabelSource
) => compareIndicatorLabels(getIndicatorLabel(a), getIndicatorLabel(b));
